import { render, staticRenderFns } from "./ConsumptionPage.vue?vue&type=template&id=3649707e&scoped=true&"
import script from "./ConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./ConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649707e",
  null
  
)

export default component.exports